import {useEffect, useState} from "react";
import useLocalStorage from "./useLocalStorage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReactPaginate from 'react-paginate';
import Masonry from "react-masonry-css";
import {faBoxArchive, faSpinner} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "../styles/resultItems.scss";
import ResultCard from "./resultCard"

export default function ResultItems({search, tags, setFilterList, currentPage, setCurrentPage, remoteApiUrlBase}) {

  // TODO => Move this OUT.
  // We call  ITEMs from API.
  // CHECK => https://scrmprox.museunacional.cat/swagger/index.html
  // HERE we HAVE to FETCH and DISPLAY data from search TERM + tags (if any)...
  // If NO q => /api/EntityWeb/GetFiltered?page=1&pageSize=12
  // If TERM => /api/EntityWeb/GetFiltered?page=1&pageSize=12&filter=guerra
  // If TAGs => /api/EntityWeb/GetFiltered?page=1&pageSize=12&tags=fons~hermen-anglada-camarasa*dates-extremes~1899-1909
  // If BOTH => /api/EntityWeb/GetFiltered?page=1&pageSize=12&filter=guerra&tags=any~1936
  const [totalItems, setTotal] = useLocalStorage("total_items_key", 0);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [receivedCards, setReceivedCards] = useState([]);

  const itemsPerPage = 12;
  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    1005: 2,
    500: 1,
  };


  // Plain CALL no search, no filters...
  let remote_url_call = remoteApiUrlBase + "/api/EntityWeb/GetFiltered?page=" + (parseInt(
    currentPage + 1)) + "&pageSize=" + itemsPerPage;
  // Call WITH search term...
  remote_url_call = (search !== null && search.length > 0) ? remote_url_call + "&filter=" + encodeURI(
    search) : remote_url_call;
  // Call WITH filters...
  if (Object.keys(tags)?.length > 0) {
    let tags_keys = Object.keys(tags),
      builtFilters = "";
    tags_keys.forEach((tag_uri_key, i) => {
      builtFilters += (i === 0) ? tag_uri_key + "~" + tags[tag_uri_key] : "*" + tag_uri_key + "~" + tags[tag_uri_key];
    });
    remote_url_call = remote_url_call + "&tags=" + builtFilters;
  }

  useEffect(() => {
    setIsLoadingData(true);
    axios.get(remote_url_call).then((response) => {

      // PREPARE each ITEM of received for new camps.
      // NEW fields come without index in metadata array...
      // AND we need to access them by key!!
      let allItems = response.data.items;
      allItems.forEach((item, i) => {

        // BEGIN test NO GALLERY
        // if(item.gallery !== null) { delete item.gallery }
        // END test NO GALLERY

        item.metadata?.forEach((metadata, j) => {
          // Remove FONT de ficha ppal...
          if (metadata.type === "Fons") {
            delete allItems[i].metadata[j];
          }
          // Move CCLicenses to its own field
          if (metadata.type === "CCLicenses") {
            allItems[i].License = metadata.value;
            delete allItems[i].metadata[j];
          }
          // Move RightHolder to its own field
          if (metadata.type === "RightHolder") {
            allItems[i].RightHolder = metadata.value;
            delete allItems[i].metadata[j];
          }
        });
      })
      setReceivedCards(allItems);
      setTotal(response.data.totalCount);
      setFilterList(response.data.facets)
      setIsLoadingData(false);
    }).catch(function (error) {
      console.log(error);
    });
  }, [search, tags, currentPage]);

  const changePage = (event) => {
    // console.log("I was clicked: " + event.selected);
    setCurrentPage(event.selected);
    window.scrollTo(0, 0);
  };
  // PAGINATOR
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  // Now go for RENDER...
  if (totalItems === 0) {
    return (
      <p>No s'han trobat documents amb els criteris de cerca.</p>
    );
  }
  else {
    return (
      <div className="r-container">
        {isLoadingData ? (
          <div className="loading-dades">
            <h2>Carregant...</h2>
            <FontAwesomeIcon icon={faSpinner} spin size="6x"/>
          </div>
        ) : (
          <div></div>
        )}

        {totalItems && (
          <div className="r-total">
            <div className="total_results"><FontAwesomeIcon icon={faBoxArchive} size="lg"/> S'han
              trobat {totalItems} resultats.
            </div>
            <div className="current-page-indicator">(mostrant pàgina {currentPage + 1} de {pageCount})</div>
          </div>
        )}

        <Masonry className="r-list" columnClassName="r-column" breakpointCols={breakpointColumnsObj}>
          {receivedCards?.map((item, i) => (
            <ResultCard resultItem={item} key={i} remoteApiUrlBase={remoteApiUrlBase}/>
          ))}
        </Masonry>

        <div className="archive_paginator">
          <ReactPaginate
            breakLabel="..."
            nextLabel="seguent >"
            onPageChange={changePage}
            pageRangeDisplayed={5}
            forcePage={currentPage}
            pageCount={pageCount}
            previousLabel="< anterior"
            renderOnZeroPageCount={null}
          />
        </div>
        )}
      </div>
    )
  }
}